import React from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';

const REPORT_TILES = [
    {
        key: 'high-time-component',
        to: '/reports/high-time-component',
        icon: '⏱️',
        title: 'High Time Component',
        description: 'CRD usage remaining waterfall by selected component',
    },
    {
        key: 'aircraft-component-life',
        to: '/reports/aircraft-component-life',
        icon: '✈️',
        title: 'Aircraft Component Life',
        description: 'Hours and calendar days remaining for every component on a selected BUNO',
    },
    {
        key: 'phase-waterfall',
        to: '/reports/phase-waterfall',
        icon: '📊',
        title: 'Phase Waterfall',
        description: 'Hours remaining until next phase inspection',
    },
    {
        key: 'strut-waterfall',
        to: '/reports/strut-waterfall',
        icon: '🛬',
        title: 'Strut Waterfall',
        description: 'Landing gear strut usage remaining from CRD All (PN 133-8*)',
    },
];

const getStyles = (theme) => {
    const isDark = theme === 'dark';
    const colors = {
        text: isDark ? '#e0e0e0' : '#212529',
        border: isDark ? '#444' : '#dee2e6',
        cardBg: isDark ? '#2a2a2a' : '#f8f9fa',
        containerBg: isDark ? '#121212' : '#fff',
        background: isDark ? '#1e1e1e' : '#fff',
        link: isDark ? '#6cb2f7' : '#007bff',
    };

    return {
        container: {
            width: '90%',
            maxWidth: '1400px',
            margin: '20px auto',
            fontFamily: 'sans-serif',
            color: colors.text,
            backgroundColor: colors.containerBg,
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px',
            flexWrap: 'wrap',
            gap: '10px',
        },
        welcomeSection: {
            backgroundColor: colors.cardBg,
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '30px',
            border: `1px solid ${colors.border}`,
        },
        tilesGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '15px',
        },
        actionCard: {
            backgroundColor: colors.cardBg,
            padding: '20px',
            borderRadius: '8px',
            border: `1px solid ${colors.border}`,
            textAlign: 'center',
            textDecoration: 'none',
            color: colors.text,
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        },
        actionIcon: {
            fontSize: '2rem',
            marginBottom: '10px',
        },
        actionTitle: {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            marginBottom: '5px',
        },
        actionDescription: {
            fontSize: '0.9rem',
            opacity: 0.8,
        },
        navLink: {
            color: colors.link,
            textDecoration: 'none',
            fontSize: '14px',
        },
        themeToggleButton: {
            padding: '8px 12px',
            border: `1px solid ${colors.border}`,
            borderRadius: '4px',
            backgroundColor: colors.background,
            color: colors.text,
            cursor: 'pointer',
            marginRight: '10px',
        },
    };
};

function ReportsHubPage({ theme, toggleTheme }) {
    const styles = getStyles(theme);

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <HamburgerMenu theme={theme} />
                <h1 style={{ flexGrow: 1, textAlign: 'center' }}>Reports</h1>
                {toggleTheme && (
                    <button type="button" onClick={toggleTheme} style={styles.themeToggleButton}>
                        {theme === 'light' ? '🌙 Dark' : '☀️ Light'}
                    </button>
                )}
                <div style={{ width: '45px' }}></div>
            </div>

            <div style={styles.welcomeSection}>
                <h2 style={{ marginTop: 0 }}>Maintenance Reports</h2>
                <p style={{ marginBottom: 8 }}>
                    Waterfall charts and component remaining-life reports. Upload source files on the Upload Data page.
                </p>
                <Link to="/" style={styles.navLink}>&larr; Back to Home</Link>
            </div>

            <div style={styles.tilesGrid}>
                {REPORT_TILES.map((tile) => (
                    <Link key={tile.key} to={tile.to} style={styles.actionCard}>
                        <div style={styles.actionIcon}>{tile.icon}</div>
                        <div style={styles.actionTitle}>{tile.title}</div>
                        <div style={styles.actionDescription}>{tile.description}</div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default ReportsHubPage;
export { REPORT_TILES };
